<template>
  <div>
    <div class="row">
      <div class="col-12 pt-0">
        <div class="card col-12 m-0">
          <div class="card-content form-group d-flex justify-content-between m-0 p-0">
            <h4 class="card-title mb-2 mt-2">Mostrar tableros: <strong>{{(globales)? 'Locales':'Globales'}}</strong></h4>
            <button @click="switchGlobales" class="btn btn-fill btn-success">
              Cambiar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-sm-4 text-center">
        <stats-card2>
          <div class="icon-big text-center icon-info" slot="header">
            <i class="fa fa-users"></i>
          </div>
          <div class="numbers" slot="content">
            <p>Obligados</p>
            {{obligados}}
          </div>
          <div class="stats" slot="inicial">
            <p>{{obligadosIn}}</p>
          </div>
          <div class="stats" slot="anual">
            <p>{{obligadosAn}}</p>
          </div>
          <div class="stats" slot="final">
            <p>{{obligadosFi}}</p>
          </div>
        </stats-card2>
      </div>
      <div class="col-lg-4 col-sm-4 text-center">
        <stats-card2>
          <div class="icon-big text-center icon-success" slot="header">
            <i class="fa fa-file"></i>

          </div>
          <div class="numbers" slot="content">
            <p>Declaraciones</p>
            {{declaraciones}}
          </div>
          <div class="stats" slot="inicial">
            <p>{{this.rinicial}}</p>
          </div>
          <div class="stats" slot="anual">
            <p>{{this.ranual}}</p>
          </div>
          <div class="stats" slot="final">
            <p>{{this.rfinal}}</p>
          </div>
        </stats-card2>


      </div>
      <div class="col-lg-4 col-sm-4 text-center">
        <stats-card2>
          <div class="icon-big text-center icon-danger" slot="header">
            <i class="fa fa-users"></i>
          </div>
          <div class="numbers" slot="content">
            <p>Faltantes</p>
            {{faltantes}}
          </div>
          <div class="stats" slot="inicial">
            <p>{{faltantesIn}}</p>
          </div>
          <div class="stats" slot="anual">
            <p>{{faltantesAn}}</p>
          </div>
          <div class="stats" slot="final">
            <p>{{faltantesFi}}</p>
          </div>
        </stats-card2>

      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <div class="card card-circle-chart">
          <div class="card-header">
            <h4 class="card-title">Declaraciones por día</h4>
            <p class="category">Se muestra la última semana</p>
          </div>
          <div class="card-content">
            <div id="chartStock" class="ct-chart"></div>
          </div>
        </div>
      </div>
      <div class="col-md-4" @click="cumplimiento">
        <circle-chart-card :percentage="porcentaje" title="Avance Global" :avance="declaraciones" :total="obligados" description="" @click="cumplimiento">
        </circle-chart-card>
      </div>
    </div>
    <div class="row" v-if="this.getKey('permisos').includes(19)">

      <div class="col-lg-4 col-sm-4 ">
        <a :href="'#/alertas/bitacora'">
          <stats-card>
            <div class="icon-big text-left icon-info" slot="header">
              <i class="fa fa-book"></i>
            </div>
            <div class="numbers titulos" slot="content">
              <p>Bitácora</p>
              <p class="category">Declaraciones Consultadas</p>
            </div>
          </stats-card>
        </a>
      </div>

      <!-- <div class="col-lg-4 col-sm-4 text-center">
        <a :href="'#/alertas/modificadas'">
          <stats-card>
            <div class="icon-big text-center icon-success" slot="header">
              <i class="fa fa-file"></i>
            </div>
            <div class="numbers titulos" slot="content">
              <p>Modificadas</p>
              <p class="category">Declaraciones Reactivadas</p>
            </div>
          </stats-card>
        </a>
      </div> -->

      <div class="col-lg-4 col-sm-4 text-center">
        <a :href="'#/admin/movimientos'">
          <stats-card>
            <div class="icon-big text-center icon-warning" slot="header">
              <i class="fa fa-check-double"></i>
            </div>
            <div class="numbers titulos" slot="content">
              <p>Vo.Bo. Correcciones</p>
              <p class="category">Aprobar Correcciones</p>
            </div>
          </stats-card>
        </a>
      </div>

    </div>


  </div>
</template>
<script>
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
import StatsCard2 from 'src/components/UIComponents/Cards/StatsCard2.vue'

  export default {
    components: {
      StatsCard,
      StatsCard2,
      ChartCard,
      CircleChartCard
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data () {
      return {
        $Chartist: null,
        globales: false,
        obligados: '',
        min: 0,
        max: 0,
        faltantes: '',
        porcentaje: 0,
        declaraciones: '',
        plugins: null,
        rinicial: 0,
        ranual: 0,
        rfinal: 0,
        obligadosIn: 0,
        obligadosAn: 0,
        obligadosFi: 0,
        faltantesIn: 0,
        faltantesAn: 0,
        faltantesFi: 0
      }
    },
    watch: {
      '$route': 'checkPermissions'
    },
    methods: {
      checkPermissions () {
        if (!(this.getKey('role') != 0)) {
          localStorage.clear()
          this.$router.push('/login')
          this.$router.go()
        }
      },
      initStockChart () {
        const dataStock = {
          labels: [],
          series: [
            []
          ]

        }
        var optionsStock = {
          lineSmooth: false,
          axisY: {
            offset: 40,
            labelInterpolationFnc (value) {
              return `${value}`
            }

          },
          low: this.min,
          height: '260px',
          high: this.max,
          classNames: {
            point: 'ct-point ct-green',
            line: 'ct-line ct-green'
          },
          plugins: [this.$Chartist.plugins.tooltip()]
        }
        const temp = []
        this.$http.get('semana').then(
          response => {
            $.each(response.data, function (key, value) {
              dataStock.labels.push(value.date)

              temp.push(value.total)
            })
            dataStock.series[0] = temp
            dataStock.labels.reverse()
            dataStock.series[0].reverse()

            var max_ = Math.max(...temp)
            var len = Math.floor(Math.log10(max_)) // + 1;
            var pow = Math.pow(10, len)
            var ceil = Math.ceil(max_ / pow) * pow
          // (pow / 10)) * (pow / 10);

            optionsStock.high = ceil
            this.$Chartist.Line('#chartStock', dataStock, optionsStock)
          },
          error => {
            this.StepError(error)
          }
        )
      },
      switchGlobales () {
        this.globales = !this.globales
        this.getDatos()
      },
      getDatos () {
        // ente_publico_id
        var obj = {
          dependencia_id: (this.globales) ? 0 : this.getKey('ente_publico_id'), // Dependencia
          estatus: 3, // Todos los usuarios
          periodo: new Date().getFullYear(), // Periodo actual
          tipo_declaracion: 4 // Todas las declaraciones
        }
        this.$http.post('repcumplimiento', obj).then(
          response => {
            /* var faltantes = 0;
            var declaraciones = 0;
            var obligados = 0;
            var porcentaje = 0;
            var rinicial = 0;
            var rfinal = 0;
            var ranual = 0;
            var faltantesIn = 0;
            var faltantesAn = 0;
            var faltantesFi = 0;
            var obligadosIn = 0;
            var obligadosAn = 0;
            var obligadosFi = 0; */

            var sumStart = {
              cumplidos: 0,
              faltantes: 0,
              faltantes_iniciales: 0,
              faltantes_anuales: 0,
              faltantes_finales: 0,
              obligados_iniciales: 0,
              obligados_anuales: 0,
              obligados_finales: 0,
              r_iniciales: 0,
              r_anuales: 0,
              r_finales: 0,
              obligados: 0,
              individual: 0,
              total: 0
            }
            var result = response.data.reduce((sum, current) => {
              sum.cumplidos += current.cumplidos
              sum.faltantes += current.faltantes
              sum.faltantes_iniciales += current.faltantes_iniciales
              sum.faltantes_anuales += current.faltantes_anuales
              sum.faltantes_finales += current.faltantes_finales
              sum.obligados_iniciales += current.obligados_iniciales
              sum.obligados_anuales += current.obligados_anuales
              sum.obligados_finales += current.obligados_finales
              sum.r_iniciales += current.r_iniciales
              sum.r_anuales += current.r_anuales
              sum.r_finales += current.r_finales
              sum.obligados += current.obligados
              sum.individual += current.individual
              sum.total += current.total
              return sum
            }, sumStart)

            this.faltantes = this.group1k(result.faltantes)
            this.declaraciones = this.group1k(result.cumplidos)
            this.obligados = this.group1k(result.obligados)
            this.porcentaje = parseFloat((result.total).toString().substring(0, 5))

            this.rinicial = this.group1k(result.r_iniciales)
            this.ranual = this.group1k(result.r_anuales)
            this.rfinal = this.group1k(result.r_finales)

            this.faltantesIn = this.group1k(result.faltantes_iniciales)
            this.faltantesAn = this.group1k(result.faltantes_anuales)
            this.faltantesFi = this.group1k(result.faltantes_finales)

            this.obligadosIn = this.group1k(result.obligados_iniciales)
            this.obligadosAn = this.group1k(result.obligados_anuales)
            this.obligadosFi = this.group1k(result.obligados_finales)
          },
          error => {
            this.StepError(error)
          }
        )
      /* this.$http.get("tableroGlobales").then(
          response => {
              this.faltantes = this.group1k(response.data.faltantes)
              this.declaraciones = this.group1k(response.data.declaraciones)
              this.obligados = this.group1k(response.data.declarantes)
              this.porcentaje = parseFloat((response.data.porcentaje).toString().substring(0,5));

              this.rinicial = this.group1k(response.data.dinic)
              this.rfinal= this.group1k(response.data.dfin)
              this.ranual= this.group1k(response.data.danu)

              this.faltantesIn = this.group1k(response.data.decIni - response.data.dinic)
              this.faltantesAn =  this.group1k(response.data.decAn - response.data.danu)
              this.faltantesFi =  this.group1k(response.data.decFin - response.data.dfin)

              this.obligadosIn =  this.group1k(response.data.decIni)
              this.obligadosAn =  this.group1k(response.data.decAn)
              this.obligadosFi =  this.group1k(response.data.decFin)

          },
          error => {
              this.StepError(error);
          }
      ); */
      },
      cumplimiento () {
        this.$router.push('/reportes/cumplimiento')
      }
      /* group1k(s) {
        let s1 = s.toString()
        if (s1.length > 3) {
          if (s1.length == 6) {
            s1 = s1.split('').reverse().join('').replace(/\d{3}/g, '$&,').split('').reverse().join('')
            return s1.substring(1, s1.length);
          } else {
            return s1.split('').reverse().join('').replace(/\d{3}/g, '$&,').split('').reverse().join('');
          }

        } else
          return s1
      } */
    },
    created () {
      this.checkPermissions()
      this.getDatos()
      if (this.getKey('permisos').includes(18)) {
        this.min = 10
        this.max = 5000
      } else {
        this.min = 0
        this.max = 500
      }
    },
    async mounted () {
      const Chartist = await import('chartist')
      this.$Chartist = Chartist
      this.initStockChart()
      this.checkCatalogs()
      this.plugins = [this.$Chartist.plugins.tooltip()]
    }

  }

</script>
<style>
  .chartist-tooltip {
    position: absolute !important;
    background: rgba(0, 0, 0, 0.6) !important;
    color: white !important;
    padding: 0px 10px !important;
    border-radius: 5px !important;
  }

  .titulos {
    text-align: left !important;
  }

  .datos {
    margin-bottom: 0px !important;
    text-align: center !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reportes/Tablero.vue